import { dwgl } from '@/axios'
import { Message } from 'element-ui'
import Xinde from '../../../dwgl/dyxxgl/components/xinde.vue'
let that;
export default{
	data(){
		return{
			getdata:{
				hyid: this.$route.query.hyid,
				flag: this.$route.query.hy_flag,
				pub_flag: this.$route.query.flag,
			},
			hyjl:{
				hyid: this.$route.query.hyid,
				record:"",
				status:2,
				flag: this.$route.query.hy_flag
			},
			attend:0,//应到人员
			attended:0,//实到人员
			fileList:[],//文件
			tags:[],//标签列表
			bindatas:"",
		}
	},
	components:{Xinde},
	created(){that = this;},
	mounted() {
		that.dataList();
	},
	methods:{
		// 获取数据
		dataList(){
			dwgl.updateActivity(that.getdata).then(res => {
				if(res.code == 200){
					res.data.dy_name = res.data.dy_name!=''?res.data.dy_name.split(',').filter(item => item!=''):[];
					res.data.sign_name = res.data.sign_name!=''?res.data.sign_name.split(',').filter(item => item!=''):[];
					that.fileList = res.data.file!=''?res.data.file:[];
					that.tags = res.data.sync_label!=''?res.data.sync_label:[];
					that.attend = res.data.dy_name.length;
					that.attended = res.data.sign_name.length;
					that.bindatas = res.data;
				}
			})
		},
		// 提交会议记录
		submitHyjl(){
			if(that.hyjl.record == ""){
				Message({
					type:'warning',
					message:"请输入会议记录后提交"
				})
			}else{
				dwgl.addHyLog(that.hyjl).then(res => {
					if(res.code == 200){
						that.$router.go(-1)
					}
				})
			}
		},
		// 下载
		download(url){
			window.open(url)
		},
		openXinde(){
			// 打开心得
			this.$refs.xinde.openXinde("我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥")
		}
	}
}